import React, { useState, useEffect, useContext } from 'react';
import {
  Card,
  Spinner,
  Button,
  Stack,
  DataTable,
  Heading,
  EmptyState,
} from '@shopify/polaris';
import ToggleButton from 'react-toggle-button';
import LoadingScreen from '../../LoadingScreen';
import { DomainContext } from '../../domain-context';

const FlowIndex = ({ handleEditFlow }) => {
  const { domain } = useContext(DomainContext);
  const [flows, setFlows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`/sms_flows?shopify_domain=${domain}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((data) => {
        setFlows(data);
        setLoading(false);
      });
  }, []);

  return (
    <Card sectioned>
      <Stack>
        <Heading>My Flows</Heading>
        <Stack.Item fill />
        <Button primary onClick={() => handleEditFlow('')}>
          Create Flow
        </Button>
      </Stack>
      <br />
      {loading ? (
        <LoadingScreen />
      ) : flows.length === 0 ? (
        <EmptyState
          heading="Generate Automated Flows"
          action={{
            content: 'Create Flow',
            onAction: () => handleEditFlow(''),
          }}
          image="/not_found.png"
        >
          <p>Create flows and notify customers using SMS.</p>
        </EmptyState>
      ) : (
        <DataTable
          columnContentTypes={[
            'text',
            'numeric',
            'numeric',
            'text',
            'text',
            'text',
          ]}
          headings={['Name', 'Sent', 'Clicks', 'Revenue', 'Status', 'Actions']}
          rows={
            !loading && flows && flows.length > 0
              ? flows
                .sort((a, b) => (b.created_at > a.created_at ? 1 : -1))
                .map((flow) => [
                  flow.name,
                  flow.sent,
                  flow.clicks,
                  `$${flow.revenue}`,
                  <ToggleButton
                    inactiveLabel={''}
                    activeLabel={''}
                    value={flow.status}
                    onToggle={(value) => {
                      const newFlow = { ...flow, shopify_domain: domain };
                      newFlow.status = !value;
                      fetch(`/sms_flows/${flow.id}`, {
                        method: 'PUT',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(newFlow),
                      })
                        .then((response) => response.json())
                        //Then with the data from the response in JSON...
                        .then((newFlow) => {
                          const newFlows = [...flows];
                          newFlows.find((f) => f.id == newFlow.id).status =
                            newFlow.status;
                          setFlows(newFlows);
                        });
                    }}
                  />,
                  <Button primary onClick={() => handleEditFlow(flow.id)}>
                    Edit
                  </Button>,
                ])
              : []
          }
        />
      )}
    </Card>
  );
};

export default FlowIndex;
